import { render } from "./CloserActions.vue?vue&type=template&id=2f0350ef"
import script from "./CloserActions.vue?vue&type=script&lang=js"
export * from "./CloserActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__